<template>
  <div class="pageContainer">
    <div style="text-align: center">
      <el-input style="width: 150px" v-model="search"></el-input>
      <el-button type="primary" @click.stop.prevent="getFactoryList">查询</el-button>
    </div>
    <div class="resultArea u-border">
      <el-table :data="tableData"
        style="width: 100%"
        empty-text="抱歉，暂无相关数据"
        v-loading="tableLoad"
        @cell-click="showDetail">
        <el-table-column prop="factory_name" label="工厂名称"></el-table-column>
        <el-table-column prop="enterprise_type_label" label="企业类别"></el-table-column>
        <el-table-column prop="product_type_label" label="生产品类"></el-table-column>
        <el-table-column prop="contact_name" label="联系人"> </el-table-column>
        <el-table-column prop="contact_phone" label="联系电话"></el-table-column>
        <el-table-column prop="contact_address" label="联系地址"></el-table-column>
        <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click.stop="showDetail(scope.row)">查看</el-button>
            </template>
        </el-table-column>
      </el-table>
      <PaginationCom
        style="display: block"
        :pageData="pageData"
        @size-change="onPageSizeChange"
        @current-change="onCurrentPageChange">
      </PaginationCom>
    </div>

  </div>
</template>

<script>
import { getCloudFactoryList } from '@/api/apii';
import { PAGINATION } from '@/helpers/baseData';
import PaginationCom from '@/views/_common/PaginationCom';

export default {
  name: 'cloudfactory',
  inject: ['myMessage'],
  components: {
    'PaginationCom': PaginationCom
  },
  data () {
    return {
      search: '',
      tableLoad: false,
      pageData: {
        total: 0,
        pageSize: PAGINATION.pageSize,
        currentPage: 1,
        selectionData: []
      },
      tableData: []
    };
  },
  methods: {
    getFactoryList () {
      this.tableLoad = true;
      const requestData = {
        page: this.pageData.currentPage,
        limit: this.pageData.pageSize,
        orderBy: ['gen_time DESC'],
        where: []
      };
      if (this.search) {
        requestData.where = [['factory_name', 'like', this.search]];
      }
      getCloudFactoryList(requestData)
        .then(res => {
          this.pageData.total = res.count;
          this.tableData = res.datalist;
        })
        .catch(() => {
          this.myMessage.megError('查询失败,请重试');
        })
        .finally(() => {
          this.tableLoad = false;
        });
    },
    onPageSizeChange (size) {
      this.pageData.pageSize = size;
      this.pageData.currentPage = 1;
      this.getFactoryList();
    },
    onCurrentPageChange (page) {
      this.pageData.currentPage = page;
      this.getFactoryList();
    },
    showDetail (row) {
      this.$router.push({
        path: `${this.$route.path}/${row.id}`
      });
    }
  },
  created () {
    this.getFactoryList();
  }
};
</script>

<style lang="scss">

</style>
